import * as React from "react";
import { IconButton as MUIIconButton } from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon";

interface IconButtonProps {
  icon?: React.ReactElement<SvgIconProps>; // The icon to be displayed
  onClick: () => void; // Function to handle click events
  ariaLabel?: string; // Optional aria-label for accessibility
  className?: string; // Optional className for custom styling
  children?: React.ReactNode; // Allow children
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  ariaLabel,
  className,
  children,
}) => {
  return (
    <MUIIconButton
      onClick={onClick}
      aria-label={ariaLabel}
      className={className}
    >
      {icon}
      {children} {/* Render any additional children here */}
    </MUIIconButton>
  );
};

export default IconButton;